/* eslint-disable no-use-before-define */
import React from 'react';
import useAutocomplete from '@material-ui/lab/useAutocomplete';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components';

const Label = styled('label')`
  padding: 0 0 4px;
  line-height: 1.5;
  display: block;
`;

const InputWrapper = styled('div')`
  border: 1px solid #d9d9d9;
  background-color: #fff;
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: #40a9ff;
  }

  &.focused {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    font-size: 14px;
    line-height: 26px;
    padding: 2px 6px;
    flex-grow: 1;
    border: 0;
    outline: 0;
  }
`;

const Tag = styled(({ label, onDelete }) => (
  <div >
    <span>{label}</span>
    <CloseIcon onClick={onDelete} />
  </div>
))`
  display: flex;
  align-items: center;
  height: 24px;
  margin: 2px;
  line-height: 22px;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;

  &:focus {
    border-color: #40a9ff;
    background-color: #e6f7ff;
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
  }
`;

const Listbox = styled('ul')`
  margin: 0;
  margin-top: 2px;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: #fff;
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;

  & li {
    padding: 5px 12px;
    display: flex;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected='true'] {
    background-color: #fafafa;
    font-weight: 600;

    & svg {
      color: #1890ff;
    }
  }

  & li[data-focus='true'] {
    background-color: #e6f7ff;
    cursor: pointer;

    & svg {
      color: #000;
    }
  }
`;


export default function CountryList(props) {
  $(".countrydel").click(function(){
    
    $("#customized-country").blur();
    $("#countrydev-"+this.id.split('-')[1]).remove();
    $("#country-li-"+this.id.split('-')[1]).removeClass('disabled');
    
  })
/* 
  $( "#customized-country" ).blur(function() {
    props.onChange();
  }); */
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    id: 'customized-country',
    defaultValue: props.country_range_json ? props.country_range_json : '',//[props.countryList[0]],
    multiple: true,
    options: props.countryList,
    getOptionLabel: option => option.title,
  });

  return (
    <div>
      <div {...getRootProps()}>
     
        <InputWrapper ref={setAnchorEl} className={focused ? 'focused' : ''}  >
          {value.map((option, index) => (
             <div className="c_tage" key={`countrydev-${option.id}`} id={`countrydev-${option.id}`}>
             <span>{option.country_name}</span>
             <svg className="MuiSvgIcon-root countrydel" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation" id={`delcountry-${option.id}`}>
               <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
             </svg>
           </div>
           
          ))}

          <input {...getInputProps()} />
        </InputWrapper>
      </div>
      {groupedOptions.length > 0 ? (
        <Listbox {...getListboxProps()}
        >
          {groupedOptions.map((option, index) => (
            <li {...getOptionProps({ option, index })}
            className={ (props.country_range != undefined) && (props.country_range == option.country_code) ? 'disabled' : null } 
            id={`country-li-${option.id}`}
            >
              <span>{option.country_name}</span>
              <CheckIcon fontSize="small" />
            </li>
          ))}
        </Listbox>
      ) : null}

      <input type="hidden" name="country_range" id="country_range" value={props.country_range_json ? JSON.stringify(props.country_range_json) : JSON.stringify(value)} onChange={props.onChange}/>
    </div>
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

